import React from 'react';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/component/title';
import 'echarts/lib/component/radar';

import 'echarts/lib/chart/radar';

import numeral from 'numeral';

/**
 * * 环节办理统计雷达图
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-07-04 
 * Version: 1.0
 * Modify log:
 */
function IndexComponent(props) {

    const { rem, dataSource } = props;

    // 各个环节办理人数与总人数比例
    let indicatorData = dataSource.map(item => {
        let percent = 0;
        if (item.zrs && item.zrs != 0) {
            let p = item.hjblrs / item.zrs * 100;
            if(p == 0 || p == 100) {
                percent =  numeral(p).format('0');
            } else {
                percent = numeral(p).format("0.00");
            }
        }

        return { name: item.hjmc, max: 100, percent: percent };
    });

    // 雷达图点描绘数据
    let seriesData = dataSource.map(item => {

        let percent = 0;
        if (item.zrs && item.zrs != 0) {
            let p = item.hjblrs / item.zrs * 100;
            if(p == 0 || p == 100) {
                percent =  numeral(p).format('0');
            } else {
                percent = numeral(p).format("0.00");
            }
        }

        return percent;
    });

    const option = {
        title: {
            text: '环节办理统计',
            textStyle: {
                color: '#05ffe3',
                fontSize: 0.18 * rem
            },
            itemGap: 20
        },
        radar: {
            name: {
                formatter: function (value, indicator) {
                    const percent = indicator.percent;
                    return '{a|' + value + '}\n{b| ' + percent + '%}';
                },
                rich: {
                    a: {
                        color: '#fff',
                        fontSize: 0.12 * rem
                    },
                    b: {
                        color: '#05ffe3',
                        fontSize: 0.12 * rem
                    }
                }
            },
            nameGap: 10,
            startAngle: 90,
            center: ['50%', '53%'],
            radius: '60%',
            splitArea: {
                areaStyle: {
                    color: 'rgba(0,0,0,0.2)',
                    shadowColor: 'rgba(0, 100, 0, 0.3)'
                }
            },
            axisLine: {
                lineStyle: {
                    color: 'rgba(255, 255, 255, 0.5)'
                }
            },
            splitLine: {
                lineStyle: {
                    color: 'rgba(255, 255, 255, 0.5)'
                }
            },
            label: {
                normal: {
                    show: true,
                    formatter: function (params) {
                        return params ? params.value : null;
                    }
                }
            },
            indicator: indicatorData
        },
        series: [
            {
                type: 'radar',
                data: [
                    {
                        value: seriesData,
                        name: '环节办理率',
                        itemStyle: {
                            normal: {
                                color: '#05ffe3'
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: 'rgba(5,255,227,0.5)'
                            }
                        }
                    }
                ]
            }
        ]
    };


    return (
        <div style={{ width: '100%', height: '100%' }}>
            <ReactEchartsCore
                style={{ width: '100%', height: '100%' }}
                echarts={echarts}
                option={option}
                notMerge={true}
                lazyUpdate={true}
            />
        </div>
    )

}

export default IndexComponent;


// WEBPACK FOOTER //
// ./containers/Show-bgy/LeftTopBox/_Radar.js